import { Swiper } from 'swiper';
import { Navigation } from 'swiper/modules';

export default class{

    /**
     * constructor
     */
    constructor(){
        this.slider = document.querySelectorAll('[data-featured-collection-slider]');
    }

    /**
     * init
     */
    init(){
        this.slider.forEach(slider => {
            const target = slider.querySelector('[data-featured-collection-slider-target]');
            new Swiper(target, {
                modules: [Navigation],
                slidesPerView: 2.25,
                spaceBetween: 16,
                breakpoints: {
                    768: {
                        slidesPerView: 3,
                        spaceBetween: 27
                    },
                    1024: {
                        slidesPerView: 4
                    },
                    1280: {
                        slidesPerView: 5
                    }
                },
                navigation: {
                    nextEl: slider.querySelector('[data-featured-collection-slider-next]'),
                    prevEl: slider.querySelector('[data-featured-collection-slider-prev]'),
                }
            });
        });

        document.addEventListener('recently-viewed-products-init', () => {
            this.recently();
        });
    }

    /**
     * recently
     */
    recently(){
        const productContainer = document.querySelector('[data-recently-collection-slider]');
        const target = productContainer.querySelector('[data-recently-collection-slider-target]');
        new Swiper(target, {
            modules: [Navigation],
            slidesPerView: 2.25,
            spaceBetween: 16,
            breakpoints: {
                768: {
                    slidesPerView: 3,
                    spaceBetween: 27
                },
                1024: {
                    slidesPerView: 4
                },
                1280: {
                    slidesPerView: 5
                }
            },
            navigation: {
                nextEl: productContainer.querySelector('[data-recently-collection-slider-next]'),
                prevEl: productContainer.querySelector('[data-recently-collection-slider-prev]'),
            }
        });
    }
}